import { UPDATE_SALES_BY_SKU_WIDGET } from "./actionTypes";

const initialState = {
  data: {}  
};

const salesBySkuWidget = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SALES_BY_SKU_WIDGET:
      // Assuming action.payload is an entity object with an id
      const entity = action.payload;
      return { ...state, data: { ...state.data, [entity.id]: entity } };

    // Add more cases as needed

    default:
      return state;
  }
};

export default salesBySkuWidget;